// @flow
import { connect } from 'react-redux'
import type { Dispatch } from 'redux'
import type { AppStateType } from '../../../../../reducers/appstate'
import type {
  DispatchPropsType,
  PropsType
} from './LinkApple'
import LinkApple from './LinkApple'
import { PROVIDERS } from '../../../../../flowTypes'
import { toggleAppleConnection } from '../../../../../actions/userActions'

const mapStateToProps = (state: AppStateType): any => {
  return ({
    isConnected: (state.user.providers || []).includes(PROVIDERS.apple),
    linkAccountRequestInProgress: state.linkAccountRequestInProgress,
    isLoading: state.linkAccountRequestInProgress && (state.linkAccountRequestProvider === PROVIDERS.apple)
  }: PropsType)
}

const mapDispatchToProps = (dispatch: Dispatch<any>): any => {
  return ({
    toggleAppleConnection: (isConnected: boolean): void => dispatch(toggleAppleConnection(isConnected))
  }: DispatchPropsType)
}

export default connect<PropsType & DispatchPropsType, {||}, _, _, _, _>(mapStateToProps, mapDispatchToProps)(LinkApple)
